import { Box } from '@material-ui/core';
import typography from '../../styles/typography.module.css';
const LineItem = (props) => {
    return (
        <>
            {props.value !== undefined ? (
                <Box style={{ width: '100%', paddingBottom: '5px' }}>
                    <Box style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                        <Box style={{ width: '30%' }}>
                            <span className={typography.detailsTitle}>{props.title}</span>
                        </Box>
                        <Box style={{ width: '45%' }}>
                            <span className={typography.detailsText}>{props.value}</span>
                        </Box>
                        <Box style={{ width: '10%' }}>
                            <span className={typography.detailsText}>{props.price}</span>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <></>
            )}
        </>
    );
};

export default LineItem;
